/**
 * Scroll-driven gradient for the custom desktop scrollbar thumb.
 *
 * WebKit scrollbar pseudo-elements (::-webkit-scrollbar-thumb) ignore CSS
 * @keyframes animations and cannot be styled via element.style, so the only
 * way to make the gradient "run" is to rewrite a stylesheet rule. This module
 * keeps a single persistent <style> element and, on scroll (throttled with
 * requestAnimationFrame), updates the thumb's background-position based on
 * scroll progress. Desktop only (matches the 750px media query in base.css);
 * Firefox ignores all of this and keeps its solid scrollbar-color fallback.
 */
(function scrollbarGradient() {
  if (typeof document === 'undefined' || !document.head || !window.matchMedia) return;

  var STYLE_ID = 'scrollbar-gradient-position';
  var mediaQuery = window.matchMedia('(min-width: 750px)');
  var styleElement = null;
  var rafId = null;

  function getStyleElement() {
    if (styleElement && styleElement.isConnected) return styleElement;
    styleElement = document.getElementById(STYLE_ID);
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = STYLE_ID;
      document.head.appendChild(styleElement);
    }
    return styleElement;
  }

  function update() {
    rafId = null;
    if (!mediaQuery.matches) return;

    var root = document.documentElement;
    if (!root) return;

    var maxScroll = root.scrollHeight - window.innerHeight;
    var progress = maxScroll > 0 ? Math.min(Math.max(window.scrollY / maxScroll, 0), 1) : 0;

    /*
     * Map scroll progress to 0%..300% so the gradient travels through several
     * repeats of its tile (background-size: 100% 400%; background-repeat:
     * repeat; with matching end stops, so wrapping is seamless) — a stronger
     * "running" feel than a single 0..100% sweep.
     */
    var positionY = (progress * 300).toFixed(2);

    /* Scoped to html so only the page scrollbar animates; inner scrollable
       elements keep the static gradient from base.css. */
    getStyleElement().textContent =
      'html::-webkit-scrollbar-thumb { background-position: 0% ' + positionY + '%; }';
  }

  function requestUpdate() {
    if (rafId === null) rafId = window.requestAnimationFrame(update);
  }

  function onMediaChange() {
    if (mediaQuery.matches) {
      requestUpdate();
    } else if (styleElement) {
      styleElement.textContent = '';
    }
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', onMediaChange);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(onMediaChange);
  }

  onMediaChange();
})();
